// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.weak-map.constructor');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/modules/es.weak-map.js
// module id = 581
// module chunks = 0 1